import { FORTA_ERROR } from '../../utils/colors';

import type { IconProps } from './types';

const WarningIcon = (props: IconProps) => {
  const { color = FORTA_ERROR, width = 24, height = 24, viewBox = '0 0 24 24' } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`${viewBox}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8936 1.72266C11.3618 0.830657 12.6382 0.830658 13.1064 1.72266L22.7891 20.1689C23.2259 21.0013 22.6216 22 21.6816 22H2.31836C1.37836 22 0.774116 21.0013 1.21094 20.1689L10.8936 1.72266Z"
        stroke={`${color}`}
        strokeWidth="1.5"
      />
      <path
        d="M10.1813 7.49141C10.084 6.42208 10.9259 5.5 11.9996 5.5C13.0737 5.5 13.9157 6.4225 13.8179 7.49205L13.0851 15.508C13.0337 16.0699 12.5625 16.5 11.9982 16.5C11.4338 16.5 10.9625 16.0697 10.9113 15.5076L10.1813 7.49141Z"
        fill={`${color}`}
      />
      <circle cx="12" cy="19" r="1.5" fill={`${color}`} />
    </svg>
  );
};

export default WarningIcon;
